import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { RouterConfig } from '../../../config/routerConfig';
import { Resource } from '../../../resource';
import { DirectionTool, StringTool, UrlTool } from '../../../tool';
import TooltipV2 from '../../tooltipV2/tooltipV2';
import './directionButton.scss';

const ICON_DIRECTION =
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M21.71,11.29l-9-9a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l9,9a1,1,0,0,0,1.42,0l9-9A1,1,0,0,0,21.71,11.29ZM14,14.5V13H10v2H8.5V11.5A.5.5,0,0,1,9,11h5V9.5L16.5,12Z" />
  </svg>

const SIZE = 36
const SIZE_EMBED = 48
function DirectionButton({ latlng, disableText, height, width, isMobile }) {
  const history = useHistory()

  const handleDirection = (e) => {
    e.stopPropagation();
    let data = DirectionTool.encodeDirection({ positions: [null, latlng] })
    let search = UrlTool.createSearch({ data: data }, { extendOldQuery: true })
    if (window.top == window.self) {
      history.push({
        pathname: RouterConfig.direction,
        search: search
      })
    }
    else {
      let url = window.location.origin + pathName + search
      window.top.open(url, "_blank")
    }

  }

  let data = DirectionTool.encodeDirection({ positions: [null, latlng] })
  let search = UrlTool.createSearch({ data: data }, { extendOldQuery: true })
  let pathName = RouterConfig.direction
  let url = window.location.origin + pathName + search

  return (
    <TooltipV2 description={Resource.common.direction} anchor='top'>
      <div className={StringTool.mergeClassName('directionButtonCpn')}>
        {
          isMobile ?
            <div className='mobileBtn'>
              <div className='icon'>{ICON_DIRECTION}</div>
              <div className='caption'>{Resource.common.way}</div>
            </div>
            :
            <div className='webBtn'>
              {
                window.top == window.self ?
                  <div
                    className='circleBtn'
                    onClick={handleDirection}
                    style={{
                      width: width ? width : SIZE,
                      height: height ? height : SIZE,
                    }}
                  >
                    {ICON_DIRECTION}
                  </div>
                  :
                  <a className='circleBtn'
                    style={{
                      marginBottom: "6px",
                      width: SIZE_EMBED,
                      height: SIZE_EMBED
                    }}
                    target='_blank'
                    href={url}
                  >
                    {ICON_DIRECTION}
                  </a>
              }
              {
                !disableText &&
                <div className='caption'>{Resource.common.direction}</div>
              }
            </div>
        }
      </div>
    </TooltipV2>
  )
}

DirectionButton.propTypes = {
  isMobile: PropTypes.bool,
  latlng: PropTypes.any,
  width: PropTypes.any,
  height: PropTypes.any,
  disableText: PropTypes.bool
};

export default DirectionButton;
